import React from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import ObligationForm from '../Forms/ObligationForm';
import ArticleForm from '../Forms/ArticleForm';

const FetchArticleModal = ({
	isOpen,
	handleClickFetchArticle,
	onArticleSelected
}) => {
	return (
		<Modal
			isOpen={isOpen}
			size='xl'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleClickFetchArticle}>
				Buscar artículo
			</ModalHeader>

			<ArticleForm
				handleClickFetchArticle={handleClickFetchArticle}
				onArticleSelected={onArticleSelected}
			/>
		</Modal>
	);
};

export default FetchArticleModal;
